import { Fragment, RefObject, ComponentType } from 'react';

import { IconProps } from '@components/icons';
import { IconAskAI } from '@components/icons/ask-ai';
import { IconAttributeJourney } from '@components/icons/attribute-journey';
import { IconAttributeTraveller } from '@components/icons/attribute-traveller';
import { IconBranch } from '@components/icons/branch';
import { IconCondition } from '@components/icons/condition';
import { IconDate } from '@components/icons/date';
import { IconDocumentCreate } from '@components/icons/document-create';
import { IconEmail } from '@components/icons/email';
import { IconForm } from '@components/icons/form';
import { IconFormatter } from '@components/icons/formatter';
import { IconHourglass } from '@components/icons/hourglass';
import { IconCode } from '@components/icons/icon-code';
import { IconIntegration } from '@components/icons/integration';
import { IconJourneyItem } from '@components/icons/journey-icon';
import { IconLoopExit } from '@components/icons/loop-exit';
import { IconLoopRestart } from '@components/icons/loop-restart';
import { IconMerge } from '@components/icons/merge';
import { IconSms } from '@components/icons/phone-sms';
import { IconPlaceholder } from '@components/icons/placeholder';
import { IconPlay } from '@components/icons/play';
import { IconReplace } from '@components/icons/replace';
import { IconTextAnonymize } from '@components/icons/text-anonymize';
import { IconTextExtract } from '@components/icons/text-extract';
import { IconWebhook } from '@components/icons/webhook';
import { Color } from '@styles/theme';

import { EditorMethods } from './text-editor';

export type EditorRefProp = { editorRef: RefObject<EditorMethods> };

export type ActionIcon = { Icon: ComponentType<IconProps>; color?: Color };

export const actionIcons: Record<string, ActionIcon> = {
  ask_ai: { Icon: IconAskAI },
  ask_ai_agent: { Icon: IconAskAI },
  calendar_event: { Icon: IconDate, color: 'elementGreen100' },
  code: { Icon: IconCode, color: 'elementIndigo100' },
  combo_send_form: { Icon: IconForm, color: 'elementBlue100' },
  condition: { Icon: IconCondition, color: 'teal100' },
  condition_v2: { Icon: IconCondition, color: 'teal100' },
  convert_document: { Icon: IconReplace, color: 'elementBlue100' },
  create_document: { Icon: IconDocumentCreate, color: 'elementBlue100' },
  formatter: { Icon: IconFormatter, color: 'elementGreen200' },
  integration: { Icon: IconIntegration, color: 'elementPurpleInvert' },
  webhook: { Icon: IconWebhook, color: 'elementGreen200' },
  journey_branch: { Icon: IconBranch, color: 'teal100' },
  journey_merge: { Icon: IconMerge, color: 'elementOrange100' },
  journey_start: { Icon: IconPlay, color: 'elementGreen100' },
  placeholder: { Icon: IconPlaceholder, color: 'elementGreen200' },
  send_email: { Icon: IconEmail, color: 'elementGreen100' },
  send_sms: { Icon: IconSms, color: 'elementGreen100' },
  journey_loop: { Icon: IconLoopRestart, color: 'teal100' },
  break_loop: { Icon: IconLoopExit, color: 'elementRed100' },
  wait_for_time: { Icon: IconHourglass, color: 'elementOrange100' },
  wait_until_fixed_date: { Icon: IconHourglass, color: 'elementOrange100' },
  wait_until_relative_date: { Icon: IconHourglass, color: 'elementOrange100' },
  update_fields: { Icon: IconAttributeJourney, color: 'elementPurpleInvert' },
  add_to_journey: { Icon: IconJourneyItem, color: 'teal100' },
  update_traveller: { Icon: IconAttributeTraveller, color: 'elementPurpleInvert' },
  anonymize_text: { Icon: IconTextAnonymize, color: 'elementIndigo100' },
  extract_text: { Icon: IconTextExtract, color: 'elementIndigo100' },

  instantiate_form: { Icon: Fragment },
  ghost: { Icon: Fragment },
  hidden: { Icon: Fragment },
  branch_base: { Icon: Fragment },
};
